<template>
    <div :class="className">
        
        <img src="../assets/images/logo.png" class="img-max-w"></div>
        <div class="content-one">
        <p class="title"><span>Nothing but</span> <span class="slogan">HEAVY DUTY. <sup class="registeredSign">&#174;</sup></span></p>
    </div>
</template>

<script>
export default {
    props: {
        className: String,
    },
    computed:{
        currentRouteName() {
            return (this.$route.name !== 'Home')? "img-max-w mainLogo":"img-max-w"
        }
    },
}
</script>

<style>

</style>